import { forwardRef } from 'react';
import { ViewProps } from './ViewProps';
import { useViewProps } from './useViewProps';

export const View = forwardRef<HTMLDivElement, ViewProps>(function View(props, ref) {
  const { children, testID, ...rest } = useViewProps(props);

  return (
    <div ref={ref} data-testid={testID} {...rest}>
      {children}
    </div>
  );
});
